import styled, { keyframes } from 'styled-components';

// Animations
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

// Styled Components
export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: ${fadeIn} 0.2s ease-in;
  border-radius: inherit;
`;

export const LoadingSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const LoadingText = styled.p`
  margin-top: 20px;
  font-size: 16px;
  color: #333;
  font-weight: 500;
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

const ModalLoadingScreen = ({ message = 'Loading...' }) => {
  return (
    <LoadingOverlay>
      <LoadingSpinner />
      <LoadingText>{message}</LoadingText>
    </LoadingOverlay>
  );
};

export default ModalLoadingScreen;
